<template>
    <div class="box p-3 pb-2 mb-3">
        <div class="row">

            <div class="col-sm-6 col-12">
                <p class="mb-3">
                    <strong class="d-block">Nome</strong>
                    {{ props.client.name }}
                </p>
            </div>

            <div class="col-sm-6 col-12">
                <p class="mb-3">
                    <strong class="d-block">E-mail</strong>
                    {{ props.client.email }}
                </p>
            </div>

            <div class="col-sm-6 col-12">
                <p class="mb-3">
                    <strong class="d-block">Telefone</strong>
                    {{ props.client.phone }}
                </p>
            </div>

            <template v-if="props.isProductor == true">

            <div class="col-sm-6 col-12">
                <p class="mb-3">
                    <strong class="d-block">CPF/CNPJ</strong>
                    {{ props.client.cpf }}
                </p>
            </div>

            <div class="col-12" v-if="props.client.address">
                <p class="mb-3">
                    <strong class="d-block">Endereço</strong>
                    {{ props.client.address }}
                </p>
            </div>

            <div class="col-6" v-if="props.client.neighborhood">
                <p class="mb-3">
                    <strong class="d-block">Bairro</strong>
                    {{ props.client.neighborhood }}
                </p>
            </div>

            <div class="col-6" v-if="props.client.address_number">
                <p class="mb-3">
                    <strong class="d-block">Número</strong>
                    {{ props.client.address_number }}
                </p>
            </div>

            <div class="col-6" v-if="props.client.complement">
                <p class="mb-3">
                    <strong class="d-block">Complemento</strong>
                    {{ props.client.complement }}
                </p>
            </div>

            <div class="col-6" v-if="props.client.city">
                <p class="mb-3">
                    <strong class="d-block">Cidade</strong>
                    {{ props.client.city }} - {{ props.client.state }}
                </p>
            </div>

            <div class="col-6" v-if="props.client.postcode">
                <p class="mb-3">
                    <strong class="d-block">CEP</strong>
                    {{ props.client.postcode }}
                </p>
            </div>
            </template>
            
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    client: {
        required: true,
        default: null
    },

    isProductor: {
        required: false,
        default: false
    }
});
</script>